import { ProductListCombinedProps } from './types';

const usePresenter = (props: ProductListCombinedProps): ProductListCombinedProps => {
  return props;
};

export default usePresenter;
